export const pathReducer = (path, ...args) => {
  const resolve = obj => path?.reduce((acc, key) => acc?.[key], obj);
  return args?.length === 0 ? resolve : resolve(args[0]);
};
